import { Button, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React, { useEffect } from 'react';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useTranslation } from 'react-i18next';
import { selectCurrentModDetails, selectModSavedStatus } from 'store/redux-store/placement-mods/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { housingInfoMsgCode } from 'app/models/Placement/PlacementMods';

const useStyles = makeStyles()({
  root: {
    backgroundColor: '#FDEDE9',
    width: '100%',
    padding: '12px 6px',
  },
  icon: {
    marginRight: 12,
    color: '#FF0000',
    fontSize: 24,
  },
  text: {
    fontSize: 14,
    alignSelf: 'center',
  },
  submitButton: {
    padding: '12px 9px',
    width: '140px',
    backgroundColor: '#006FB9',
    color: '#FFFFFF',
    '&:hover': {
      backgroundColor: '#006FB9',
    },
    marginRight: '24px',
    marginLeft: '24px',
    fontSize: '12px',
    height: '38px',
    '& .MuiInputBase-root.Mui-disabled': {
      pointerEvents: 'auto',
    },
  },
});

export const ModsFormBanner = ({
  message,
  refreshButton,
  refreshAction,
}: {
  message: string;
  refreshButton?: any;
  refreshAction?: any;
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const currentModDetails = useSelector(selectCurrentModDetails);
  const dispatch = useDispatch();
  const modSavedResponse = useSelector(selectModSavedStatus);

  // setting true housing informative banner after showing first time
  const settingTrueAfterDisplay = () => {
    const storage = JSON.parse(localStorage.getItem('housingBannerMsg'));
    if (storage && storage.length > 0) {
      let updateStorage: any = storage;
      let recordNotFound = true;
      for (let index = 0; index < storage.length; index++) {
        const item = storage[index];
        if (item.travelerOptionId === currentModDetails?.travelerOptionId) {
          storage[index].msgShown = true;
          recordNotFound = false;
        }
      }
      if (recordNotFound) {
        updateStorage.push({
          travelerOptionId: currentModDetails?.travelerOptionId,
          msgShown: true,
        });
      }
      localStorage.setItem('housingBannerMsg', JSON.stringify(updateStorage));
    } else {
      localStorage.setItem(
        'housingBannerMsg',
        JSON.stringify([
          {
            travelerOptionId: currentModDetails?.travelerOptionId,
            msgShown: true,
          },
        ]),
      );
    }
  };
  useEffect(() => {
    if (modSavedResponse?.responseCode === housingInfoMsgCode) {
      settingTrueAfterDisplay();
      dispatch(placementModsAction.setHousingBannerDisplay(true));
    }
  }, []);
  return (
    <Grid
      container
      justifyContent="center"
      direction={'row'}
      alignContent="center"
      className={classes.root}
      wrap="nowrap"
    >
      <ErrorOutlineIcon className={classes.icon} />
      <Grid item className={classes.text}>
        {message}
      </Grid>
      {refreshButton && (
        <Button
          variant="contained"
          onClick={e => {
            refreshAction();
          }}
          className={classes.submitButton}
        >
          {t('placement.placementMods.refresh')}
        </Button>
      )}
    </Grid>
  );
};
